// extracted by mini-css-extract-plugin
module.exports = {"defs-only":"ColorOverlay-module__defs-only___3HMj0","blue-overlay":"ColorOverlay-module__blue-overlay___26MSg","gray-overlay":"ColorOverlay-module__gray-overlay___2xyqY"};